var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.9993 29.3332C23.3631 29.3332 29.3327 23.3636 29.3327 15.9998C29.3327 8.63604 23.3631 2.6665 15.9993 2.6665C8.63555 2.6665 2.66602 8.63604 2.66602 15.9998C2.66602 23.3636 8.63555 29.3332 15.9993 29.3332Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4118 16L20.4785 12.9333C20.8652 12.5466 20.8652 11.9066 20.4785 11.52C20.0918 11.1333 19.4518 11.1333 19.0652 11.52L15.9985 14.5866L12.9318 11.52C12.5452 11.1333 11.9052 11.1333 11.5185 11.52C11.1318 11.9066 11.1318 12.5466 11.5185 12.9333L14.5852 16L11.5185 19.0666C11.1318 19.4533 11.1318 20.0933 11.5185 20.48C11.7185 20.68 11.9718 20.7733 12.2252 20.7733C12.4785 20.7733 12.7318 20.68 12.9318 20.48L15.9985 17.4133L19.0652 20.48C19.2652 20.68 19.5185 20.7733 19.7718 20.7733C20.0252 20.7733 20.2785 20.68 20.4785 20.48C20.8652 20.0933 20.8652 19.4533 20.4785 19.0666L17.4118 16Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c61d7cbec6dc1989cf15e5acb98dd67d.svg";
export { ForwardRef as ReactComponent };